export default {
  general: {
    back: 'Volver a la cuenta',
    backFarm: 'Volver a la Granja',
  },
  user: {
    settings: 'Configuración de la cuenta'
  },
  summary: {
    title: 'Financieros',
    yesterday: 'Ingresos de ayer',
    total: 'Ingresos por todo el tiempo',
    withdrawn: 'Retirado',
    balance: 'Saldo',
    withdrawNow: 'Retirada',
    income: "Income",
    todayEstimate: "Today’s estimate:",
    finance: "Finance",
    incomeHistory: "Income history",
    withdrawalHistory: "Withdrawal history",
    totalIncomeHint1: "Total income does not includes today income",
    totalIncomeHint2: "Today income will be credited to your balance at 00:00 UTC (London time)",
  },
  farms: {
    title: 'Sus granjas',
    share: 'Su participación',
    yesterday: 'Ingresos de ayer',
    total: 'Ingresos por todo el tiempo',
    view: 'Más información'
  },
  table: {
    total: 'En total',
    noData: 'No se encontraron registros'
  },
  income: {
    title: 'Historial de ingresos',
    amount: 'Suma',
    date: 'Fecha',
    farm: 'Granja',
  },
  withdrawals: {
    title: 'Historial de la retirada',
    amount: 'Suma',
    date: 'Fecha',
    address: 'Dirección',
    status: 'Estatus',
    pending: 'Espera',
    paid: 'Listo',
    withdrawNow: 'Nueva retirada'
  },
  account: {
    title: 'Configuración de la cuenta',
    enterName: 'Su nombre',
    saveChanges: 'Guardar cambios',
    changesSaved: 'Cambios guardados',
    saving: 'Conservación...',
    retypeNewPassword: 'Repita la contraseña',
    passwordSaved: 'Nueva contraseña guardada',
    deleteAccount: '¿Quiere eliminar su cuenta?',
    contactSupport: 'Póngase en contacto con el soporte',
    questions: '¿Tiene alguna pregunta sobre sus pedidos?',
    getHelp: 'Necesito ayuda',
    wrongPassword: 'Contraseña incorrecta',
    oldPassword: 'Contraseña antiguaь',
    min6chars: 'Mínimo 6 caracteres',
    newPassword: 'Nueva contraseña',
    loginMethods: 'Métodos de inicio de sesión',
    viaPassword: "Contraseña",
    viaSocial: 'Dentro de ',
    enterCurrentPassword: 'Contraseña actual',
    change: 'Cambiar',
    remove: 'Eliminar',
    setPassword: 'Crear',
    removeWarning: 'Si elimina la contraseña, solo podrá iniciar sesión a través de Google.',
    removePassword: 'Eliminar contraseña',
    removingPassword: 'Eliminando contraseña...',
    cancel: 'Cancelar',
    disable: 'Prohibir',
    enable: 'Permitir',
    twitterTokenAccess: 'Twitter Bot Access Token',
    generateToken: 'Generate Token',
    deleteToken: 'Delete Token',
  },
  farmInfo: {
    'deviceDetails': 'Detalles del Dispositivo',
    'model': 'Modelo',
    'hashrate': 'Tasa de hash: ',
    'power': 'Potencia: ',
    'watts': 'Vatios',
    'price': 'Precio',
    'desc': 'La Granja Minera Grupal "%miniFarmTitle%" consta de %devices% dispositivos. ' +
        'Es una de las máquinas mineras más populares.',
    'desc2': 'Usted se convierte en socio de Xive y copropietario de la granja "%miniFarmTitle%"' +
        'de acuerdo con el porcentaje que adquirió. Los precios de hardware y hosting' +
        ' siguen siendo los mismos que los de Xive. Xive solo aplica una Comisión de gestión ' +
        'del 20% a las ganancias recibidas',
    'desc3': 'Xive применяет только %miniFarmServiceFee% управленческую комиссию к полученным прибылям.',
    'deviceDesc': '%count% устройств %model% с хешрейтом %rate% каждое',
    'groupMiningDetails': 'Сведения о групповой майнинговой ферме',
    'totalHashrate': 'Hashrate total',
    'totalValue': 'Valor total',
    'devices': 'Dispositivos',
    'hostingDetails': 'Detalles de Hosting',
    'electricityFee': 'Tarifa de Hosting',
    'kwh': 'KW / h',
    'securityDeposit': 'Depósito de Hosting',
    'days': 'Días',
    'profitSharing': 'Comisión de participación',
  },
  farmSummary: {
    title: 'Financieros',
    yesterday: 'Ingresos de ayer',
    total: 'Ingresos por todo el tiempo',
    deposit: 'Depósito',
    stake: 'Participación en la granja'
  },
  farmIncome: {
    title: 'Historial de ingresos',
    amount: 'Suma',
    date: 'Fecha'
  },
  farmOrders: {
    title: 'Historial de compras',
    date: 'Fecha',
    stake: 'Participación en la granja',
    amount: 'Costo',
    deposit: 'Depósito'
  },
  withdrawal: {
    sendBtc: 'Retiro BTC',
    loadingBalance: 'Carga de saldo...',
    network: 'Red:',
    selectNetwork: 'Seleccione una red',
    bitcoinNetwork: 'Bitcoin red',
    binanceNetwork: 'BNB Smart Chain (BEP20)',
    address: 'Dirección:',
    invalidAddress: 'Dirección incorrecta',
    walletOk: 'Dirección OK',
    mainnetRequired: 'requiere MainNet monedero',
    mustBeBitcoinNetwork: 'La dirección del monedero debe ser una dirección de   <b> red Bitcoin</b> válida',
    mustBeBinanceNetwork: 'La dirección del monedero debe ser una dirección válida de  <b>Binance BEP 20 (BSC)</b> ',
    transactionsIrreversible: 'Todas las transacciones BTC son irreversibles: si introduce una dirección BTC incorrecta, sus <b>fondos se perderán!</b>',
    sendFrom: 'Enviar',
    selectWallet: 'Seleccione un monedero',
    amount: 'Suma:',
    max: 'Max.',
    available: 'Disponible:',
    minAmount: 'Mínimo:',
    notEnoughBalance: 'Su saldo no es suficiente para retirar:',
    receiveAmount: 'Monto por cobrar:',
    calculating: 'recuento...',
    networkFee: 'Comisión de la red',
    continue: 'Continuar',
    checking: 'Comprobación...',
    confirmWithdrawal: 'Confirmación de retirada',
    verifyWithdrawal: 'Por favor, confirme la retirada',
    sixDigitsSent: 'Se ha enviado un código de seis dígitos a su dirección de correo electrónico, revise su correo',
    confirm: 'Confirmar',
    withdrawalRequested: 'Retirada confirmada',
    willBeWithdrawn: 'La cantidad solicitada será enviada dentro de unas pocas horas',
    close: 'Cerrar',
    wrongCode: 'Has introducido un código incorrecto, compruebe el código',
    enterCryptoAddress: 'Introduzca criptomonedero',
    enterAmount: 'Introduzca la cantidad',
  }
}